import { Platform } from 'react-native';
import * as Linking from 'expo-linking';

const createUrl = (path: string, queryParams?: Linking.QueryParams) => Linking.createURL(Platform.OS === 'web' ? '/' + path : path, {
    isTripleSlashed: false,
    queryParams: queryParams
});

export default createUrl;
